import React from 'react';
import { Container, Form, Button, Card, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMusic } from '@fortawesome/free-solid-svg-icons';
import '../components/components.css';

const MusicIdentification = () => {
  return (
    <Container className="py-4 beats-component-container">
      <h2>Music Identification</h2>
      <p>Identify songs, melodies, and audio samples using AI.</p>
      
      <Card className="my-4 p-4 beats-card">
        <div className="text-center mb-4">
          <div 
            className="d-inline-flex justify-content-center align-items-center rounded-circle beats-bg-gradient" 
            style={{ width: '100px', height: '100px', cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faMicrophone} size="3x" color="white" />
          </div>
          <h4 className="mt-3">Tap to Listen</h4>
        </div>
        
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Or Upload Audio Sample</Form.Label>
            <Form.Control type="file" accept="audio/*" className="beats-form-control" />
            <Form.Text className="text-muted beats-form-text">
              Upload a short audio clip (max 15 seconds)
            </Form.Text>
          </Form.Group>
          
          <Button variant="primary" type="submit" className="w-100 mb-4 beats-btn-primary">
            Identify Music
          </Button>
        </Form>
        
        <div className="mt-4">
          <h5>Recent Identifications</h5>
          <ListGroup>
            <ListGroup.Item className="d-flex justify-content-between align-items-center beats-list-item">
              <div>
                <FontAwesomeIcon icon={faMusic} className="me-2" />
                <span className="fw-bold">Bohemian Rhapsody</span> - Queen
              </div>
              <small className="text-muted beats-form-text">2 days ago</small>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex justify-content-between align-items-center beats-list-item">
              <div>
                <FontAwesomeIcon icon={faMusic} className="me-2" />
                <span className="fw-bold">Billie Jean</span> - Michael Jackson
              </div>
              <small className="text-muted beats-form-text">1 week ago</small>
            </ListGroup.Item>
          </ListGroup>
        </div>
      </Card>
    </Container>
  );
};

export default MusicIdentification; 